import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class LocalPickup extends Component {
  /** @type {AbortController | undefined} */
  #activeFetch;

  connectedCallback() {
    super.connectedCallback();

    // Sofort ausblenden, sobald das Element geladen wird
    this.setAttribute('hidden', '');

    const closestSection = this.closest(`.shopify-section, dialog`);

    /** @type {(event: VariantUpdateEvent) => void} */
    const variantUpdated = (_event) => {
      // Immer verstecken – unabhängig von Variante oder Verfügbarkeit
      this.setAttribute('hidden', '');
    };

    closestSection?.addEventListener(ThemeEvents.variantUpdate, variantUpdated);

    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(ThemeEvents.variantUpdate, variantUpdated);
    };
  }

  // Fetch wird nie gebraucht, da wir nichts anzeigen
  #fetchAvailability = () => {
    this.setAttribute('hidden', '');
  };
}

if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}
